import { Link } from 'react-router-dom';
import { categoryMeta, resources } from '@/mocks/resources';

export default function CategoryGrid() {
  return (
    <section className="mx-auto w-full px-4 md:px-8">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            按类型快速找到你想看的国语影音资源
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categoryMeta.map((cat) => {
          const count = resources.filter((r) => r.category === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-1 flex-1 text-sm leading-relaxed text-foreground-600">
                {cat.desc}
              </p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span className="font-label">共 {count} 部资源</span>
                <span className="inline-flex items-center gap-1 text-primary-600">
                  进入频道
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}